export default __webpack_public_path__ + "static/media/cork.02018694.jpg";